exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-button[data-v-64ffae20]{position:absolute;top:12px;right:21px}", ""]);

// exports
